import React, { useEffect, useState } from 'react';
import { Spin } from 'antd';
import styles from './area-of-interest.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import talentProfileApi from '../../services/talentProfiles';
import { TP_PRINT_SECTION_NAME } from '../TalentProfilePrintPreview/constants';
import { updatePrintData } from '../../pages/TalentProfilePage/store/printProfileSlice';
import { updateDownloadData } from '../../pages/TalentProfilePage/store/downloadProfileSlice';

const AreaOfInterest = (props) => {
  const { profileId, isPrintTP, fetchedData, tokenTalentProfile } = props;
  const [loading, setLoading] = useState(false);
  const user = useSelector((state) => state.user);
  const [areaOfInterest, setAreaOfInterest] = useState('');
  const dispatch = useDispatch();

  const fetchApi = async () => {
    if (!user.roleActive || !profileId) return;

    try {
      setLoading(true);
      const response = await talentProfileApi.fetchAreaOfInterest({
        profileId,
        roleUser: user,
        tokenTalentProfile,
      });

      if (response.status === 200) {
        const result = response?.data?.result?.areaOfInterest;
        setAreaOfInterest(result || '');
        dispatch(
          updatePrintData({
            sectionName: TP_PRINT_SECTION_NAME.AREAS_OF_INTEREST,
            data: result,
          })
        );
        dispatch(
          updateDownloadData({
            sectionName: TP_PRINT_SECTION_NAME.AREAS_OF_INTEREST,
            data: result,
          })
        );
      }
    } catch (err) {
      setAreaOfInterest('');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isPrintTP && fetchedData) {
      setAreaOfInterest(fetchedData);
      return;
    }
    fetchApi();
  }, [user.roleActive.roleId, profileId, fetchedData, isPrintTP]);

  return (
    <div className={styles.SectionPlan} data-print-section={TP_PRINT_SECTION_NAME.AREAS_OF_INTEREST}>
      <div className={styles.SectionName}>
        <span>Areas of Interest</span>
      </div>
      <Spin spinning={loading} size="small">
        <div className={styles.SectionContent} dangerouslySetInnerHTML={{ __html: areaOfInterest }} />
      </Spin>
    </div>
  );
};

export default AreaOfInterest;
